let nextNotificationId = 0

export const addNotification = notification => ({
  type: 'ADD_NOTIFICATION',
  id: nextNotificationId++,
  text: String(notification.text),
  color: notification.color || 'info',
})

export const removeNotification = notification => ({
  type: 'REMOVE_NOTIFICATION',
  id: notification.id,
})

export default (state = [], action) => {
  switch (action.type) {
    case 'ADD_NOTIFICATION':
      return [
        ...state,
        {
          id: action.id,
          text: action.text,
          color: action.color || 'info',
        },
      ]

    case 'REMOVE_NOTIFICATION':
      return state.filter(n => {
        return n.id !== action.id
      })

    default:
      return state
  }
}
